// Registration is handled by ZITADEL. This route simply redirects to the login
// page where the user can choose to sign in or create a new account via ZITADEL.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function RegisterPage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/login", { replace: true });
  }, [navigate]);
  return null;
}
